module.exports = __webpack_public_path__ + "media/images/icon__betPick--pick@3x-da745e1a9782ff73f0724b561f7d4940.png";